export const categoryInfo = [
  {
    id: "general_knowledge",
    icon_name: "question_exchange",
    label: "Mixed General Knowledge",
  },
  {
    id: "music",
    icon_name: "music_note",
    label: "Music",
  },
  {
    id: "sports_and_leisure",
    icon_name: "surfing",
    label: "Sports and Leisure",
  },
  {
    id: "film_and_tv",
    icon_name: "movie",
    label: "Film and TV",
  },
  {
    id: "arts_and_literature",
    icon_name: "brush",
    label: "Arts and Literature",
  },
  {
    id: "society_and_culture",
    icon_name: "diversity_3",
    label: "Society and Culture",
  },
  {
    id: "science",
    icon_name: "experiment",
    label: "Science",
  },
  {
    id: "geography",
    icon_name: "landscape",
    label: "Geography",
  },
  {
    id: "food_and_drink",
    icon_name: "restaurant",
    label: "Food and Drink",
  },
  {
    id: "history",
    icon_name: "history_edu",
    label: "History",
  },
];

export const categoryIdLabelMap = {
  general_knowledge: "Mixed General Knowledge",
  music: "Music",
  sports_and_leisure: "Sports and Leisure",
  film_and_tv: "Film and TV",
  arts_and_literature: "Arts and Literature",
  society_and_culture: "Society and Culture",
  science: "Science",
  geography: "Geography",
  food_and_drink: "Food and Drink",
  history: "History",
};

export const categoryIds = {
  general_knowledge: "general_knowledge",
  music: "music",
  sports_and_leisure: "sports_and_leisure",
  film_and_tv: "film_and_tv",
  arts_and_literature: "arts_and_literature",
  society_and_culture: "society_and_culture",
  science: "science",
  geography: "geography",
  food_and_drink: "food_and_drink",
  history: "history",
};
